import React from 'react'
import {usePartnerScheduling} from './use-partner-scheduling'
import {SchedulerAppointmentView} from './scheduler-appointment-view'

// Call scheduler for Partner 1:Many, Influencer and Keap Partner links.
// Rules + API calls: use-partner-scheduling.js. Date window rules:
// utils/partner-scheduling.js. Markup: scheduler-appointment-view.js.
export const SchedulerAppointmentComponent = props => {
  const scheduler = usePartnerScheduling(props)
  return <SchedulerAppointmentView scheduler={scheduler} />
}
